import {
  type UseMutationOptions,
  type UseMutationResult,
  useMutation,
} from '@tanstack/react-query';

import api from 'src/axios';

export type ProductSalesPotential = {
  sku: string;
  sales_potential: number;
};

export const useUpsertProductsSalesPotential = (
  options?: Omit<
    UseMutationOptions<void, Error, ProductSalesPotential>,
    'mutationFn'
  >,
): UseMutationResult<void, Error, ProductSalesPotential> => {
  return useMutation({
    mutationFn: async (product: ProductSalesPotential) => {
      await api.post('/products/sales-potential', product);
    },
    ...options,
  });
};
